import { getUUID } from '@shared/utils/global-id';

export const hasBuyerLeadInStage = (
  buyerLeads: readonly {
    id: string;
    stage_id?: string | null;
  }[],
  buyerLeadIds: readonly string[],
  stageId: string,
) => {
  const buyerLeadIdsSet = new Set(buyerLeadIds);

  return buyerLeads.some(
    buyerLead =>
      buyerLeadIdsSet.has(buyerLead.id) && buyerLead.stage_id === stageId,
  );
};

export const getEmailedBuyerLeadIdsInStage = (
  buyerLeads: readonly {
    id: string;
    stage_id?: string | null;
  }[],
  sentRecipients: readonly {
    buyerLeadId?: string;
  }[],
  stageId?: string,
) => {
  if (stageId == null) {
    return [];
  }

  const sentRecipientLeadIds = new Set(
    sentRecipients
      .map(recipient => recipient.buyerLeadId)
      .filter((buyerLeadId): buyerLeadId is string => buyerLeadId != null)
      .map(getUUID),
  );

  return buyerLeads
    .filter(
      buyerLead =>
        buyerLead.stage_id === stageId &&
        sentRecipientLeadIds.has(buyerLead.id),
    )
    .map(buyerLead => buyerLead.id);
};
